import { QueueSettings } from '@prisma/client';

export const DEFAULT_QUEUE_SETTINGS: Pick<
  QueueSettings,
  | 'enabled'
  | 'allowArtistsToPull'
  | 'collectArtistPreference'
  | 'collectServiceDetails'
  | 'waiverBehavior'
> = {
  enabled: true,
  allowArtistsToPull: true,
  collectArtistPreference: true,
  collectServiceDetails: true,
  waiverBehavior: 'IMMEDIATE',
};
